import { useDisplay } from 'vuetify'
import BeerEventTile from '@/components/EventTiles/BeerEventTile.vue'
import BlueWhiteEventTile from '@/components/EventTiles/BlueWhiteEventTile.vue'
import FriendlyMatchEventTile from '@/components/EventTiles/FriendlyMatchEventTile.vue'
import LeagueEventTile from '@/components/EventTiles/LeagueEventTile.vue'
import TrainingEventTile from '@/components/EventTiles/TrainingEventTile.vue'

/**
 * Composable pro dynamický výběr tile komponenty podle event.type.
 * Na mobilu (smAndDown) se pro league/superliga vrací LeagueEventTileSm.
 */
export function useEventTileResolver() {
  const { smAndDown } = useDisplay()

  const getEventTileComponent = (eventType?: string) => {
    switch (eventType) {
      case 'beer':
        return BeerEventTile
      case 'blue-white':
        return BlueWhiteEventTile
      case 'friendly-match':
        return FriendlyMatchEventTile
      case 'training':
      case 'camp':
        return TrainingEventTile
      case 'superliga':
      default:
        return LeagueEventTile
    }
  }

  return { getEventTileComponent }
}
